import { createAction } from 'shared/utils';

export const AMENITIES = {
  GET: createAction('AMENITIES_GET'),
  GET_PRIORITY_IN_APP_SELECTED: createAction('AMENITIES_GET_PRIORITY_IN_APP_SELECTED'),
  GETS: createAction('AMENITIES_GETS'),
  ADD: createAction('AMENITIES_ADD'),
  UPDATE: createAction('AMENITIES_UPDATE'),
};
